import { Link } from "@circleco/compass/components/Link";

import { useProfileLinkProps } from "@/react/hooks/profile/useProfileLinkProps";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

interface ProfileLinkProps {
  id: string;
  name: string;
}

export const ProfileLink = ({ name, id }: ProfileLinkProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled(
    "circle_v4_typography_enabled",
  );
  const linkProps = useProfileLinkProps({
    name,
    public_uid: id,
    params: { show_back_link: true },
  });

  if (isCircleV4) {
    return (
      <Link
        variant="custom"
        typography="body-sm"
        color="link"
        {...linkProps}
        style={{ display: "inline" }}
      >
        {name}
      </Link>
    );
  }

  return (
    <a {...linkProps} style={{ display: "inline" }}>
      {name}
    </a>
  );
};
